import theme from './index';

export default {
  token: {
    fontFamily: 'Oswald',
    borderRadius: 4,
    colorPrimary: theme.colors['terra-cotta']
  },
  components: {
    Button: {
      fontFamily: 'OswaldLight',
      colorPrimaryTextHover: 'black'
    },
    Select: {
      fontFamily: 'OswaldLight',
      colorBorder: 'rgb(232 234 235) !important',
      colorPrimaryBorder: 'rgb(232 234 235) !important',
      colorPrimaryHover: 'rgb(232 234 235) !important',
      colorPrimaryActive: 'rgb(232 234 235) !important',
      boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)'
    },
    InputNumber: {
      fontFamily: 'OswaldLight',
      colorBorder: 'rgb(232 234 235) !important',
      colorPrimaryBorder: 'rgb(232 234 235) !important',
      colorPrimaryHover: 'rgb(232 234 235) !important',
      colorPrimaryActive: 'rgb(232 234 235) !important',
      boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)'
    },
    Badge: {
      dotSize: 10
    },
    Segmented: {
      trackPadding: 4,
      trackBg: 'rgb(38, 45, 53)'
    }
  }
};
